import React, { useState } from 'react';
import { Globe, Check } from 'lucide-react';
import { LANGUAGES, CURRENCIES } from '../i18n/translations';
import { useLocale } from '../context/LocaleContext';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const LocaleSwitcher = () => {
  const { language, setLanguage, currency, setCurrency, t } = useLocale();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="flex items-center gap-1.5 text-[11px] font-semibold text-gray-700 hover:text-[#22c55e] transition px-2 py-1 rounded border border-gray-200 hover:border-[#22c55e]">
          <span className="text-base leading-none">{current.flag}</span>
          <span className="hidden md:inline">{current.code.toUpperCase()}</span>
          <span className="text-gray-400">|</span>
          <span>{currency}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-0" align="end">
        <div className="p-3 border-b">
          <div className="text-[10px] font-bold text-gray-500 tracking-wider mb-2">{t('language').toUpperCase()}</div>
          <div className="space-y-1">
            {LANGUAGES.map((l) => (
              <button
                key={l.code}
                onClick={() => setLanguage(l.code)}
                className={`w-full flex items-center justify-between px-2 py-2 rounded text-sm transition ${language === l.code ? 'bg-[#f0fdf4] text-[#22c55e] font-semibold' : 'hover:bg-gray-50'}`}
              >
                <span className="flex items-center gap-2">
                  <span className="text-lg">{l.flag}</span>
                  <span>{l.label}</span>
                </span>
                {language === l.code && <Check size={14} />}
              </button>
            ))}
          </div>
        </div>
        <div className="p-3">
          <div className="text-[10px] font-bold text-gray-500 tracking-wider mb-2">{t('currency').toUpperCase()}</div>
          <div className="grid grid-cols-2 gap-2">
            {CURRENCIES.map((c) => (
              <button
                key={c.code}
                onClick={() => setCurrency(c.code)}
                className={`px-3 py-2 rounded text-sm font-semibold border transition ${currency === c.code ? 'bg-[#22c55e] text-white border-[#22c55e]' : 'border-gray-200 hover:border-[#22c55e] text-gray-700'}`}
              >
                {c.symbol} {c.code}
              </button>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default LocaleSwitcher;
